export default __webpack_public_path__ + "static/media/ezgif-1-997e5035cba4.d3b66b82.png";